import React from "react";
import * as Constants from "../../constants";

// NJC/MCPJ/5 – "Relative ages of pending cases" laid out like the NJC form.
// Used on the report screen (one page of rows) and on the print page (all rows).

const fmt = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  if (isNaN(dt)) return "";
  return `${String(dt.getDate()).padStart(2, "0")}/${String(
    dt.getMonth() + 1,
  ).padStart(2, "0")}/${dt.getFullYear()}`;
};

// 1,245 days -> "1,245 days (3y 4m)"
const formatAge = (days) => {
  if (days === null || days === undefined) return "";
  const y = Math.floor(days / 365);
  const m = Math.floor((days % 365) / 30);
  const parts = [];
  if (y > 0) parts.push(`${y}y`);
  if (m > 0) parts.push(`${m}m`);
  return `${Number(days).toLocaleString()} day${days === 1 ? "" : "s"}${
    parts.length ? ` (${parts.join(" ")})` : ""
  }`;
};

const cell = { border: "1px solid #000", padding: "4px 6px", verticalAlign: "top" };
const head = { ...cell, textAlign: "center", fontWeight: 600, fontSize: 12 };
const fill = { borderBottom: "1px solid #000", padding: "0 8px", minWidth: 180, display: "inline-block" };

export default function Njc5Form({ header = {}, rows = [], startIndex = 0, showSignatures = true }) {
  return (
    <div className="njc5-form" style={{ fontSize: 13, color: "#000" }}>
      <div style={{ textAlign: "center", fontWeight: 700, fontSize: 16 }}>NATIONAL JUDICIAL COUNCIL</div>
      <div style={{ textAlign: "center", fontWeight: 600, fontSize: 12 }}>
        MONITORING COMMITTEE ON PERFORMANCE OF JUDICIAL OFFICERS OF SUPERIOR COURTS OF RECORD
      </div>

      <div style={{ textAlign: "center", marginTop: 12 }}>
        STATE: {header.state || "Lagos State"}. COURT NO <span style={fill}>{header.courtNo}</span>
      </div>
      <div style={{ textAlign: "center", marginTop: 8 }}>
        DIVISION:{" "}
        <span style={fill}>
          {header.division}
          {header.division ? ", (High Court of Lagos State)" : ""}
        </span>
      </div>

      <div style={{ textAlign: "center", fontSize: 18, marginTop: 14 }}>RELATIVE AGES OF PENDING CASES</div>
      <div style={{ marginTop: 6, display: "flex", gap: 24, flexWrap: "wrap" }}>
        <span>
          AS AT BEGINNING OF <span style={fill}>{header.quarterNumber} Quarter</span>
        </span>
        <span>
          Quarter covered: <span style={fill}>{header.quarterCovered}</span>
        </span>
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 10 }}>
        <thead>
          <tr>
            <th style={head} rowSpan={2}>S/No</th>
            <th style={head}>(A)</th>
            <th style={head}>(B)</th>
            <th style={head}>(C)</th>
            <th style={head}>(D)</th>
            <th style={head}>(E)</th>
            <th style={head}>(F)</th>
            <th style={head}>(G)</th>
          </tr>
          <tr>
            <th style={head}>Type of Case</th>
            <th style={head}>Case Number</th>
            <th style={head}>Date of Filing</th>
            <th style={head}>Date of Assignment of Case</th>
            <th style={head}>Date of Commencement of Hearing</th>
            <th style={head}>Age of Case (Present Date - E)</th>
            <th style={head}>Remarks (Stage/Status of Case)</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td style={{ ...cell, textAlign: "center" }} colSpan={8}>
                No pending cases
              </td>
            </tr>
          )}
          {rows.map((r, i) => (
            <tr key={r.caseId ?? i}>
              <td style={{ ...cell, textAlign: "center" }}>{startIndex + i + 1}</td>
              <td style={cell}>{r.caseType}</td>
              <td style={cell}>{r.caseNumber}</td>
              <td style={cell}>{fmt(r.filingDate)}</td>
              <td style={cell}>{fmt(r.assignedDate)}</td>
              <td style={cell}>{r.hearingCommencedOn ? fmt(r.hearingCommencedOn) : "Not yet commenced"}</td>
              <td style={cell}>{formatAge(r.ageDays)}</td>
              <td style={cell}>{r.remarks}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ fontSize: 11, marginTop: 4 }}>
        Present date: {fmt(header.presentDate)}
      </div>

      {showSignatures && (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 32, flexWrap: "wrap", gap: 16 }}>
            <div>
              Name of Judge: <span style={fill}>{Constants.judgeTitle(header.judgeName)}</span>
            </div>
            <div style={{ textAlign: "center" }}>
              Confirmed by: <span style={fill}>{Constants.judgeTitle(header.chiefJudgeName)}</span>
              <div style={{ fontWeight: 600, marginTop: 4 }}>HEAD OF COURT</div>
            </div>
          </div>
          <div style={{ marginTop: 24 }}>
            Signature and Date: <span style={fill}>&nbsp;</span>
          </div>
        </>
      )}
    </div>
  );
}
